import type { GameService } from './types'

const game: GameService = {
    name: 'camelrace',
    category: 'minigames',
    placeholder: false,
    disable: true,
    onlineAvailable: false,
    // Camel Race configures its target via the starter selector, so the setup
    // screen shows no match settings and no dart-setup selector.
    hideDartSetup: true,
    form: [],
    content: {
        type: 'camel_race',
        duration: [10, 20],
        difficulty: 'medium',
        player_count: '2 - 4',
        starterSelectorContent: {
            titleKey: 'game_content.camelrace.starter_selector_title',
            descriptionKey: 'game_content.camelrace.starter_selector_description',
        },
        images: {
            banner: '',
            tile: '',
        },
    },
}

export default game
